import { BilbyHeader } from '@/components/bilby-header';
import { ContentPanel } from '@/components/content-panel';
import { useCurrentUser } from '@/hooks';
import { PrimaryLayout } from '@/layouts/primary';
import { TopNavFor } from '@/layouts/primary/top-nav';
import { Card, Flex, Loader, Table } from '@mantine/core';
import { useGetScanHistoryQuery } from './graphql.generated';
import styles from './styles.module.css';

export const ScanHistoryPage = () => {
	const { currentUser, loading: currentUserLoading } = useCurrentUser();
	const { data, loading } = useGetScanHistoryQuery({
		variables: { userId: currentUser?.id ?? '' },
		skip: !currentUser?.id,
	});

	return (
		<PrimaryLayout header={{ title: 'Scan History', backTo: '/home' }} topNav={TopNavFor.ACCOUNT}>
			<ContentPanel hasTopNav width="md" gap="md">
				<BilbyHeader title="Scan History" bilby="checklist" />
				<Card w="100%" radius="xl" withBorder shadow="xs" className={styles.scanTable}>
					<Table>
						<Table.Thead>
							<Table.Tr>
								<Table.Th>Date</Table.Th>
								<Table.Th>Entries</Table.Th>
								<Table.Th>Material</Table.Th>
								<Table.Th>Code</Table.Th>
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>
							{data?.scanEvents?.map((scan) => (
								<Table.Tr key={scan?.id}>
									<Table.Td className={styles.tableCell}>
										{new Date(scan?.createdAt).toLocaleDateString()}
									</Table.Td>
									<Table.Td className={styles.tableCell}>{scan?.entriesGained}</Table.Td>
									<Table.Td className={styles.tableCell}>{scan?.material}</Table.Td>
									<Table.Td className={styles.tableCell}>
										{scan?.trackableAsset?.scannableCode}
									</Table.Td>
								</Table.Tr>
							))}
							{Boolean(
								!currentUserLoading &&
									!loading &&
									Boolean(data?.scanEvents?.length === 0 || !data?.scanEvents)
							) && (
								<Table.Tr h={200}>
									<Table.Td align="center" colSpan={4} c="dimmed">
										You haven&apos;t scanned any items yet.
									</Table.Td>
								</Table.Tr>
							)}
							{(currentUserLoading || loading) && (
								<Table.Tr h={200}>
									<Table.Td align="center" colSpan={4} c="dimmed">
										<Flex align="center" justify="center">
											<Loader size="sm" mr="lg" />
											Fetching your scan history...
										</Flex>
									</Table.Td>
								</Table.Tr>
							)}
						</Table.Tbody>
					</Table>
				</Card>
			</ContentPanel>
		</PrimaryLayout>
	);
};
